<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    data(){
      return {

      }
    },
    created(){
      document.title = '后台管理系统'

      //登录状态持久化 && localStorage.quanjian
      if (localStorage.token && localStorage.userinfo ) {
        let userinfo = JSON.parse(localStorage.userinfo)

        this.$store.commit('status/ISLOGIN', true)
        this.$store.commit('userinfo/USERINFO', userinfo)

        if (localStorage.fullPath){
          //保证页面刷新后 路由还是原页面 不加会跳转首页
          if (localStorage.fullPath) this.$router.replace(localStorage.fullPath)
        } else {
          this.$router.replace("/evnt_mgt");
        }
      }
    },
    watch: {
      $route(to, from) {
        if (to.fullPath != from.fullPath) {
          localStorage.fullPath = to.fullPath //保证页面刷新后 路由还是原页面 不加会跳转首页
        }
      }
    }
  }
</script>

<style>
  
</style> 
